import { render, staticRenderFns } from "./BenefitRow.vue?vue&type=template&id=57b4fa34"
import script from "./BenefitRow.vue?vue&type=script&lang=js"
export * from "./BenefitRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports